export default __webpack_public_path__ + "static/media/ovo.970ec343.svg";